import UserInterfaceV1, { UserInterfaceV1Type } from './UserInterfaceV1';
import { getServices } from '../../../infra/startup';
import {
  AuthenticationDataType,
  UserDataInterfaceV1Type
} from '@clientos/types';
import { internalLogger } from '../clientOsLogger';

let userInterfaceV1: UserInterfaceV1;

export function getUserInterfaceV1(): UserInterfaceV1 {
  return userInterfaceV1;
}

export default async function initializeUserInterfaceV1(): Promise<UserInterfaceV1Type> {
  if (userInterfaceV1) return userInterfaceV1.getInterface();
  const services = getServices();
  const { userOnboardingService, userService } = services;

  userInterfaceV1 = new UserInterfaceV1({
    userOnboardingService,
    userService
  });

  return userInterfaceV1.getInterface();
}

export function createNoopUserInterfaceInterface(): UserInterfaceV1Type {
  return {
    getUserData: function (): Promise<UserDataInterfaceV1Type> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopUserInterfaceInterface',
        methodName: 'getUserData()',
        message: 'Noop interface method called - returning null'
      });
      return Promise.resolve(null);
    },
    _userData: {
      get: function (): Promise<UserDataInterfaceV1Type> {
        /* istanbul ignore next */
        internalLogger?.debug?.d5({
          className: 'createNoopUserInterfaceInterface',
          methodName: '_userData.get()',
          message: 'Noop interface method called - returning null'
        });
        return Promise.resolve(null);
      }
    },
    useAuthenticationData: function (React: any): AuthenticationDataType {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopUserInterfaceInterface',
        methodName: 'useAuthenticationData()',
        message:
          'Noop interface method called - returning default authentication data'
      });
      return {
        isLoggedIn: false,
        userData: null
      };
    },
    getResidenceCountry: function (): Promise<string> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopUserInterfaceInterface',
        methodName: 'getResidenceCountry()',
        message: 'Noop interface method called - returning empty string'
      });
      return Promise.resolve('');
    },
    onboarding: {
      isUserOnboarded: function (): Promise<boolean> {
        /* istanbul ignore next */
        internalLogger?.debug?.d5({
          className: 'createNoopUserInterfaceInterface',
          methodName: 'onboarding.isUserOnboarded()',
          message: 'Noop interface method called - returning false'
        });
        return Promise.resolve(false);
      },
      joinInvitedOrganization: function (): Promise<void> {
        /* istanbul ignore next */
        internalLogger?.debug?.d5({
          className: 'createNoopUserInterfaceInterface',
          methodName: 'onboarding.joinInvitedOrganization()',
          message: 'Noop interface method called - no operation performed'
        });
        return Promise.resolve();
      },
      onboardUser: function (): Promise<void> {
        /* istanbul ignore next */
        internalLogger?.debug?.d5({
          className: 'createNoopUserInterfaceInterface',
          methodName: 'onboarding.onboardUser()',
          message: 'Noop interface method called - no operation performed'
        });
        return Promise.resolve();
      },
      shouldRenderOnboardingScreen: function (): Promise<boolean> {
        /* istanbul ignore next */
        internalLogger?.debug?.d5({
          className: 'createNoopUserInterfaceInterface',
          methodName: 'onboarding.shouldRenderOnboardingScreen()',
          message: 'Noop interface method called - returning false'
        });
        return Promise.resolve(false);
      }
    }
  };
}
